import { useContext, useEffect, useState } from 'preact/hooks';

import { useSelector } from '@/redux/helper';
import { GlobalsContext } from '@/shared/context';

// eslint-disable-next-line import/prefer-default-export
export const useUnreadBellNotificationCount = () => {
  const userId = useSelector((state) => state.user.userId);
  const [unread, setUnread] = useState(0);
  const { socket, userSocket } = useContext(GlobalsContext);

  useEffect(() => {
    const socketHandler = ({ unread }: { unread: number }) => {
      setUnread(unread);
    };

    if (!socket || !userSocket || !userId) {
      return undefined;
    }

    userSocket.on('receiveNotifications', socketHandler);
    socket.emit('getNotifications', { userId });

    return () => {
      userSocket.off('receiveNotifications', socketHandler);
    };
  }, [socket, userSocket, userId]);

  return unread;
};
